// import {
//   StyledBtnLink,
//   StyledLinkContainer,
//   StyledNavLink,
//   StyledStaticNavLink,
// } from "./nav-link.style";
// import {AnalyticsEvent} from "../../../utils/analytics";

// interface INavLinkProps {
//   children?: {
//     to: string;
//     label: string;
//   }[];
//   to: string;
//   label: string;
//   icon: React.ReactNode;
//   isComingSoon?: boolean;
//   isBtnLink?: boolean;
// }

// const NavLink: React.FC<INavLinkProps> = ({
//   children,
//   to,
//   label,
//   icon,
//   isComingSoon,
//   isBtnLink,
// }) => {
//   return (
//     <StyledLinkContainer
//       onClick={() => AnalyticsEvent("Navigation Link", `Clicked on ${label}`)}
//     >
//       {isComingSoon ? (
//         <StyledStaticNavLink>
//           <div className="nav-icon-container">{icon}</div>
//           <span className="nav-label">{label}</span>
//           <div className="coming-soon-bubble">Coming soon</div>
//         </StyledStaticNavLink>
//       ) : isBtnLink ? (
//         <StyledBtnLink href={to} target="_blank">
//           <div className="nav-icon-container">{icon}</div>
//           <span className="nav-label">{label}</span>
//         </StyledBtnLink>
//       ) : (
//         <StyledNavLink to={to}>
//           <div className="nav-icon-container">{icon}</div>
//           <span className="nav-label">{label}</span>
//           {/* {isComingSoon && <div className="coming-soon-bubble">Coming soon</div>} */}
//         </StyledNavLink>
//       )}
//     </StyledLinkContainer>
//   );
// };

// export {NavLink};

import React from "react";
import {CaretDownFilled, CaretUpFilled} from "@ant-design/icons";
import {useLocation} from "react-router-dom";
import {
  StyledBtnLink,
  StyledChevronButton,
  StyledLinkContainer,
  StyledNavLink,
  StyledStaticNavLink,
  StyledSubmenu,
  StyledSubmenuItem,
} from "./nav-link.style";
import {AnalyticsEvent} from "../../../utils/analytics";

interface INavLinkProps {
  children?: {to: string; label: string}[];
  to: string;
  label: string;
  icon: React.ReactNode;
  isComingSoon?: boolean;
  isBtnLink?: boolean;
}

/** Split a "to" string into pathname + search, ignoring hash */
function splitPathAndSearch(to: string) {
  const qIndex = to.indexOf("?");
  if (qIndex === -1) return {path: to, search: ""};
  return {path: to.slice(0, qIndex), search: to.slice(qIndex)};
}

const NavLink: React.FC<INavLinkProps> = ({
  children,
  to,
  label,
  icon,
  isComingSoon,
  isBtnLink,
}) => {
  const location = useLocation();
  // const {pathname, search} = location;

  const hasChildren = Array.isArray(children) && children.length > 0;

  // Determine if a specific child is active (exact pathname; strict search matching)
  // const isSubItemActive = (childTo: string) => {
  //   const {path: cPath, search: cSearch} = splitPathAndSearch(childTo);
  //   if (pathname !== cPath) return false;
  //   // If child defines a search, require exact match; if it doesn't, current search must be empty
  //   return cSearch ? search === cSearch : search === "";
  // };

  const isSubItemActive = (childTo: string) => {
    const {path: cPath, search: cSearch} = splitPathAndSearch(childTo);
    return (
      location.pathname === cPath &&
      (cSearch ? location.search === cSearch : location.search === "")
    );
  };

  // Parent considered active if any child is active
  const isChildActive = hasChildren && children!.some((c) => isSubItemActive(c.to));

  // Auto-open when a child route is active
  const [open, setOpen] = React.useState<boolean>(!!isChildActive);
  React.useEffect(() => {
    if (isChildActive) setOpen(true);
  }, [isChildActive]);

  if (isComingSoon) {
    return (
      <StyledLinkContainer
        onClick={() => AnalyticsEvent("Navigation Link", `Clicked on ${label}`)}
      >
        <div className="row">
          <StyledStaticNavLink>
            <div className="nav-icon-container">{icon}</div>
            <span className="nav-label">{label}</span>
            <div className="coming-soon-bubble">Coming soon</div>
          </StyledStaticNavLink>
        </div>
      </StyledLinkContainer>
    );
  }

  if (isBtnLink) {
    return (
      <StyledLinkContainer
        onClick={() => AnalyticsEvent("Navigation Link", `Clicked on ${label}`)}
      >
        <div className="row">
          <StyledBtnLink href={to} target="_blank" rel="noreferrer">
            <div className="nav-icon-container">{icon}</div>
            <span className="nav-label">{label}</span>
          </StyledBtnLink>
        </div>
      </StyledLinkContainer>
    );
  }

  return (
    <StyledLinkContainer
      onClick={() => AnalyticsEvent("Navigation Link", `Clicked on ${label}`)}
    >
      <div className="row">
        {/* Parent: mark active if router says active OR any child is active */}
        <StyledNavLink
          to={to}
          className={({isActive}) => (isActive || isChildActive ? "active" : undefined)}
        >
          <div className="nav-icon-container">{icon}</div>
          <span className="nav-label">{label}</span>
        </StyledNavLink>

        {hasChildren && (
          <StyledChevronButton
            type="button"
            aria-label={open ? "Collapse submenu" : "Expand submenu"}
            aria-expanded={open}
            aria-controls={`submenu-${label.replace(/\s+/g, "-").toLowerCase()}`}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setOpen((v) => !v);
            }}
          >
            {open ? <CaretUpFilled /> : <CaretDownFilled />}
          </StyledChevronButton>
        )}
      </div>

      {hasChildren && (
        <StyledSubmenu
          id={`submenu-${label.replace(/\s+/g, "-").toLowerCase()}`}
          $open={open}
        >
          {children!.map((c) => {
            const active = isSubItemActive(c.to);
            return (
              <li key={c.to}>
                {/* Force exact-child activation using our own className logic */}
                <StyledSubmenuItem
                  to={c.to}
                  // end
                  // className={active ? "my-guy" : undefined}
                  // IMPORTANT: provide a className FUNCTION so NavLink uses ONLY what you return.
                  // We ignore NavLink's own isActive (pathname-only) and use our strict matcher.
                  // className={() => (isSubItemActive(c.to) ? "active" : undefined)}
                  className={isSubItemActive(c.to) ? "active" : undefined}
                >
                  {c.label}
                </StyledSubmenuItem>
              </li>
            );
          })}
        </StyledSubmenu>
      )}
    </StyledLinkContainer>
  );
};

export {NavLink};
